import React from 'react';
import { Helmet } from 'react-helmet';
import PageNavigation from './PageNavigation';
import { useDispatch } from 'react-redux';
import { getClientWelcomeReminders } from '../../../../../../redux/slices/clientsSlice';
import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';

export default function UserCommunicationTimingsPage() {
    const dispatch = useDispatch();
    const params = useParams();

    useEffect(() => {
        dispatch(getClientWelcomeReminders(params?.id));
    }, [dispatch, params?.id]);

    return (
        <div>
            <Helmet>
                <title>Console Defentry - User communication - Timings</title>
            </Helmet>
            <div className="navigation-tabs__wrapper">
                <PageNavigation />
            </div>
            <Outlet />
        </div>
    );
}
